<template>
  <div>
    <el-dialog
            :visible="dialogVisible"
            width="20%"
            style="min-width: 350px"
            :modal="true"
            :before-close="handleClose"
            :close-on-click-modal="true">

      <div id="number-autocomplete" class="header-input">
        <div>
          <div class="contact-container">
            <div v-if="selectedPerson">
              <contact
                class="contact-container"
                v-if="!selectedPerson.hasOwnProperty('COMPANY') && !selectedPerson.hasOwnProperty('contactType')"
                :name="selectedPerson.name"
                :number="null"
                :email="selectedPerson.email"
                :status="selectedPerson.extStatus"
                :branch="selectedPerson.branch"
                :department="selectedPerson.department"
                :dnd="''"
                :avatar="selectedPerson.avatarPath">
              </contact>
              <personal-contact
                v-if="selectedPerson.hasOwnProperty('COMPANY')"
                class="contact-container"
                :firstName="selectedPerson.FIRSTNAME"
                :lastName="selectedPerson.LASTNAME"
                :number="null"
                :email="selectedPerson.EMAIL"
                :show-company="false"
                :company="selectedPerson.COMPANY">
              </personal-contact>
              <other-contact
                v-if="selectedPerson.hasOwnProperty('contactType')"
                class="contact-container"
                :type="selectedPerson.contactType"
                :name="selectedPerson.name"
                :number="selectedPerson.number"
              />
            </div>
          </div>
        </div>
        <el-autocomplete
          ref="autoComplete"
          v-model="number"
          value-key="nameNumber"
          :fetch-suggestions="suggestContacts"
          placeholder="Enter Name or Number"
          clearable
          :trigger-on-focus="false"
          @select="handleSelect"
          @clear="clearContact">
          <template slot-scope="scope">
            <contact
              v-if="!scope.item.hasOwnProperty('COMPANY') && !scope.item.hasOwnProperty('contactType')"
              :name="scope.item.name"
              :number="null"
              :email="scope.item.email"
              :status="scope.item.extStatus"
              :dnd="scope.item.dnd"
              :branch="scope.item.branch"
              :department="scope.item.department"
              :avatar="scope.item.avatarPath">
            </contact>
            <personal-contact
              v-if="scope.item.hasOwnProperty('COMPANY')"
              :firstName="scope.item.FIRSTNAME"
              :lastName="scope.item.LASTNAME"
              :number="null"
              :email="scope.item.EMAIL"
              :company="scope.item.COMPANY"
              :show-company="false">
            </personal-contact>
            <other-contact
              v-if="scope.item.hasOwnProperty('contactType')"
              class="contact-container"
              :type="scope.item.contactType"
              :name="scope.item.name"
              :number="scope.item.number"
            />
          </template>
        </el-autocomplete>
      </div>

      <div class="button-container" v-if="isTransferRequest">

        <div class="button-wrapper call-btn">
          <el-tooltip content="Blind Transfer" placement="top">
            <el-button @click="processTransfer" class="table-action-button">
              <v-svg class="voxo-green" sprite="transfer"></v-svg>
            </el-button>
          </el-tooltip>
        </div>

        <div class="button-wrapper call-btn">
          <el-tooltip content="Attended Transfer" placement="top" class="table-action-button">
            <el-button @click="processTransferAT">
              <v-svg class="voxo-aqua" sprite="call-forward"></v-svg>
            </el-button>
          </el-tooltip>
        </div>

        <div class="button-wrapper call-btn">
          <el-tooltip content="Conference" placement="top" class="table-action-button">
            <el-button @click="processTransferAT">
              <v-svg class="voxo-red" sprite="group"></v-svg>
            </el-button>
          </el-tooltip>
        </div>

        <div class="button-wrapper call-btn" v-if="userCanPark">
          <el-tooltip content="Park for user" placement="top" class="table-action-button">
            <el-button @click="processPark">
              <v-svg class="voxo-orange" sprite="call-park"></v-svg>
            </el-button>
          </el-tooltip>
        </div>

      </div>

      <div class="keypad-container">
        <el-row>
          <el-button type="text" @click="updateInput(1)">
            <div class="btn-number-blank">1</div>
          </el-button>
          <el-button type="text" @click="updateInput(2)">
            <div class="btn-number">2</div>
            ABC
          </el-button>
          <el-button type="text" @click="updateInput(3)">
            <div class="btn-number">3</div>
            DEF
          </el-button>
        </el-row>
        <el-row>
          <el-button type="text" @click="updateInput(4)">
            <div class="btn-number">4</div>
            GHI
          </el-button>
          <el-button type="text" @click="updateInput(5)">
            <div class="btn-number">5</div>
            JKL
          </el-button>
          <el-button type="text" @click="updateInput(6)">
            <div class="btn-number">6</div>
            MNO
          </el-button>
        </el-row>
        <el-row>
          <el-button type="text" @click="updateInput(7)">
            <div class="btn-number">7</div>
            PQRS
          </el-button>
          <el-button type="text" @click="updateInput(8)">
            <div class="btn-number">8</div>
            TUV
          </el-button>
          <el-button type="text" @click="updateInput(9)">
            <div class="btn-number">9</div>
            WXYZ
          </el-button>
        </el-row>
        <el-row>
          <el-button type="text" @click="updateInput('*')">
            <div class="btn-number-blank">*</div>
          </el-button>
          <el-button type="text" @click="updateInput(0)">
            <div class="btn-number">0</div>
            +
          </el-button>
          <el-button type="text" @click="updateInput('#')">
            <div class="btn-number-blank">#</div>
          </el-button>
        </el-row>
      </div>
      <div class="button-container">
        <div class="button-wrapper call-btn" v-if="!isTransferRequest">
          <el-tooltip :content="!softphoneEnabled ? 'Call from Deskphone' : 'Call From Softphone'" placement="top">
            <el-button v-if="!softphoneEnabled" @click="dialCall" class="table-action-button icon-blue">
              <v-svg sprite="telephone"/>
            </el-button>
            <el-button v-else @click="dialCall" class="table-action-button icon-blue">
              <v-svg sprite="headset"/>
            </el-button>
          </el-tooltip>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import feathersClient from "../../../../feathers/feathers-client";
  import Contact from "../../contacts/components/contact";
  import PersonalContact from "../../contacts/components/personal-contact";
  import OtherContact from "./other-contact";
  import {globalEventBus} from '../../../../globalEventBus';
  import { debounce } from 'lodash';

  export default {
    name: 'Keypad',
    components: {Contact, PersonalContact, OtherContact},
    data() {
      return {
        number: '',
        selectedPerson: null,
        inputElement: null,
        currentSuggestions: [],
        transferItem: null,
        isTransferRequest: false
      };
    },
    computed: {
      ...mapGetters('phonebook-entries', {getPhonebookEntries: 'find'}),
      user(){
        return this.$store.state.auth.user;
      },
      userHostServer(){
        return this.$store.state.userHostServer;
      },
      dialogVisible() {
        return this.$store.state.softphoneVisible;
      },
      personalDirectory() {
        return this.getPhonebookEntries({
          query: {
            hasDetails: true,
            phonebookId: this.user.myExtension.omniaPhonebookId,
            $sort: {
              FIRSTNAME: 1
            }
          }
        }).data;
      },
      softphoneEnabled(){
        return this.$store.state.softphoneEnabled;
      },
      userCanPark(){
        if(this.user){
          const {myExtension} = this.user;
          if(!myExtension){
            return false;
          }
          return !!myExtension.enableParking;
        }
        return false;
      }
    },
    watch: {
      number(){
        //strip special characters
        this.number = this.number.replace(/['":/{}()[|\-.<>?_=+ \]]/g, '');
        if(!this.number.length){
          this.selectedPerson = null
        }
      },
      dialogVisible(){
        if(this.dialogVisible){
          setTimeout( () => {
            const numberField = document.getElementById('number-autocomplete').querySelector('input');
            this.inputElement = numberField;
            numberField.focus();
          }, 250);
        } else{
          this.$refs.autoComplete.suggestions = [];
          this.$store.commit('setSoftphoneTransfer', false);
          this.isTransferRequest = false;
          this.transferItem = null;
          this.clearContact();
        }
      }
    },
    methods: {
      handleClose() {
        this.$store.commit('setSoftphoneVisibility', false);
        this.$store.commit('setSoftphoneTransfer', false);
        this.isTransferRequest = false;
        this.transferItem = null;
        this.clearContact();
      },
      updateInput(value) {
        this.number = this.number + value;
      },
      async suggestContacts(queryString, cb) {

        const { isResidential } = this.user.myExtension;
        const searchTerm = (queryString + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0')

        //grab all entities that can use extension dialing, not just extensions
        let directory = [];
        if(!isResidential)
        directory = await feathersClient.service('extensions').find({
          query: {
            entityType: 'all',
            tenantId: this.user.myExtension.tenantId,
            includeInPb: 'yes',
            $or: [
              {number: {$like: `%${searchTerm}%`}},
              {name: {$like: `%${searchTerm}%`}}
            ],
            $limit: 25
          }
        });

        let personal = queryString ? this.personalDirectory.filter(this.filterPersonal(queryString)) : this.personalDirectory;
        const results = [...directory, ...personal];
        this.currentSuggestions = results;
        this.$refs.autoComplete.highlightedIndex = 0;
        cb(results);
      },
      filterPersonal(queryString){
        return (contact) => {
          return (contact.NAME.toLowerCase().indexOf(queryString.toLowerCase()) === 0 || contact.PHONE1.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      handleSelect(item) {
        this.selectedPerson = item;
        if(item.hasOwnProperty('PHONE1')){
          this.number = item.PHONE1;
          this.name = item.NAME;
        } else{
          this.number = item.number;
          this.name = item.name;
        }
      },
      clearContact(){
        this.number = '';
        this.name = '';
        this.selectedPerson = null
      },
      processTransfer(){
        const {sipHandle, channel, systemname, softphoneCall} = this.transferItem;

        //handle this on a desk phone
        if(!softphoneCall){
          feathersClient.service('nats-actions-handler').create({
            reqType: 'transfer',
            channel,
            ext: this.number,
            server:systemname
          });
          this.handleClose();
          return
        }

        //handle on a softphone session
        const callItem = {channel, systemname};
        globalEventBus.$emit('softphoneProcessTransfer', {sipHandle, destination: this.number, channel, callItem});
        this.handleClose();
      },
      processTransferAT(){
        const {sipHandle, channel, systemname, softphoneCall} = this.transferItem;

        //do this for a desk phone
        if(!softphoneCall){
          feathersClient.service('nats-actions-handler').create({
            reqType: 'transferAT',
            channel: channel,
            ext: this.number,
            server:systemname
          });
          this.$store.commit('mycurrentcalls/updateItem', {channel, atxferActive: true, atxferCallerId: this.number});
          this.handleClose();
          return;
        }

        //handle on a softphone session
        const callItem = {channel, systemname};
        globalEventBus.$emit('softphoneProcessAttendedTransfer', {sipHandle, destination: this.number, callItem});
        this.$store.commit('mycurrentcalls/updateItem', {channel, atxferActive: true, atxferCallerId: this.number});
        this.handleClose();
      },
      processPark(){
        const { sipHandle, channel, systemname, cidname, cidnum, direction, peerName, softphoneCall } = this.transferItem;

        //check for user number
        if(!this.number){
          this.$notify({
            title: 'No Extension',
            message: "You must enter an extension",
            type: "error"
          });
          return;
        }

        //do this for a desk phone
        if(!softphoneCall){
          feathersClient.service('nats-actions-handler').create({
            reqType: 'softphonePark',
            channel,
            cidname,
            cidnum,
            direction,
            peerName,
            server: systemname,
            parkedFor: `${this.number}-${this.user.myExtension.tenantCode}`
          });
          this.handleClose();
          return;
        }

        //do this for a softphone session
        const callItem = {channel, systemname};
        globalEventBus.$emit('softphoneParkForUser', {sipHandle, destination: this.number, callItem});
        this.handleClose();
      },
      dialCall(){

        //return a clean number while storing and DTMF
        const { number } = this.storeDTMF();

        //strip special characters
        this.number = number;

        if(this.softphoneEnabled){
          this.$emit('softphoneDial', this.number);
          this.handleClose();
        } else {
          const {peerName} = this.user.myExtension;
          feathersClient.service('nats-actions-handler').create({
            reqType: 'notifyOriginate',
            number: this.number,
            peerName
          });

          //cannot dial DTMF on hard phone so just drop these from the store if exists
          this.$store.commit('removeDTMFNumbers', number);
          this.handleClose();
        }
      },
      storeDTMF(){
        //this function returns a clean number to dial and stores any DTMF in the store
        //sanitize any characters we do not consider
        this.number = this.number.replace(/['":/{}()[|\-.<>?_=+ \]]/g, '');

        //checking for a delimiter of type comma
        if(this.number.includes(',')){

          const numberSplit = this.number.split(',');
          const dtmf = [];

          for(let i = 1; i < numberSplit.length; i++){
            dtmf.push(numberSplit[i]);
          }

          //store the dtmf on this number
          const storePayload = {};
          storePayload[numberSplit[0]] = dtmf;
          this.$store.commit('addDTMFPayload', storePayload);

          return {
            number: numberSplit[0],
            dtmf
          }

        }

        //checking for delimiter of type semicolon
        if(this.number.includes(';')){
          const numberSplit = this.number.split(';');
          const dtmf = [];

          for(let i = 1; i < numberSplit.length; i++){
            dtmf.push(numberSplit[i]);
          }

          //store the dtmf on this number
          const storePayload = {};
          storePayload[numberSplit[0]] = dtmf;
          this.$store.commit('addDTMFPayload', storePayload);

          return {
            number: numberSplit[0],
            dtmf
          }
        }

        return {
          number: this.number,
          dtmf: []
        }

      }
    },
    mounted(){

      //event listener for our click to call chrome extension
      window.addEventListener('dialClick', debounce( (evt) =>  {
        const {number} = evt.detail;
        this.number = number;
        this.dialCall();
      }, 500));


      globalEventBus.$on('transferRequest', (item) => {
        this.isTransferRequest = true;
        this.transferItem = item;
      });

      globalEventBus.$on('headsetRedial', number => {
        this.number = number;
      });

      window.addEventListener('keypress', (event) => {
        if(this.dialogVisible && this.inputElement){
          if(this.inputElement === document.activeElement){
            if(event.key === 'Enter'){
              if(this.selectedPerson && !this.isTransferRequest){
                this.dialCall();
              } else if(this.number.length && this.currentSuggestions.length){
                this.handleSelect(this.currentSuggestions[0]);
                this.$refs.autoComplete.suggestions = [];
              } else {
                if(this.number.length && !this.currentSuggestions.length && !this.isTransferRequest){
                  this.dialCall();
                }
              }
            }
          }
        }
      });

    },
    beforeDestroy(){
      window.removeEventListener('keypress', () => {
        console.log('keypress listener killed');
      });
      globalEventBus.$off(['transferRequest']);
    }
  }
</script>

<style lang="scss" scoped>

  @import '../../../../assets/scss/_variables';
  @import '../../../../assets/scss/_mixins';

  .contact-item{
    padding: 3px 0;
    .number-details{
      margin-left: 0 !important;
    }
  }

  .contact-container{
    height: 40px;
  }


  .header-input {
    width: 85%;
    margin: 0 auto;
  }

  .button-container {
    text-align: center;
    padding: 12px;
    display: flex;
    justify-content: center;
  }

  .button-wrapper {
    margin: 10px 10px 0;
  }

  .el-autocomplete{
    width: 100%;
  }

  .contact-info {
    margin: 10px;

    .checkbox-wrapper {
      display: flex;
      justify-content: center;
    }

    .el-button {
      color: $voxo-blue;
      font-size: 15px;
    }

    ::placeholder {
      text-align: left;
      font-size: 17px;
    }

  }
</style>
